import React from 'react';

const INIT_STATE = {
  farmList: [],
  selectedFarm: {},
  farmSource: {},
  farmMqttStatus: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case "FARM_LIST": {
      return {
        ...state,
        farmList: action.payload
      };
    }
    case "SELECTED_FARM": {
      return {
        ...state,
        selectedFarm: action.payload
      };
    }
    case "SELECTED_FARM_SCOUT": {
      return {
        ...state,
        selectedFarmScout: action.payload
      };
    }
    case "FARM_SOURCE": {
      return {
        ...state,
        farmSource: action.payload
      };
    }
    case "FARM_ACTUATOR": {
      return {
        ...state,
        farmActuators: action.payload
      };
    }
    case "FARM_MQTT_STATUS": {
      return {
        ...state,
        farmMqttStatus: action.payload
      };
    }
    default:
      return state;

  }
}


